import { render, staticRenderFns } from "./RedeemTransactionCustomer.vue?vue&type=template&id=3b946076&scoped=true&"
import script from "./RedeemTransactionCustomer.vue?vue&type=script&lang=js&"
export * from "./RedeemTransactionCustomer.vue?vue&type=script&lang=js&"
import style0 from "./RedeemTransactionCustomer.vue?vue&type=style&index=0&id=3b946076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b946076",
  null
  
)

export default component.exports